export default __webpack_public_path__ + "static/media/flohmarkt_logo.374d6c99.svg";